import {Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {TranslateUtils} from '../../../_shared/translate-utils';
import {Subscription} from 'rxjs';
import {
    DeviceStateEnum,
    DumpsterDto,
    DumpsterProvider,
    DumpsterService,
} from '../../../_services/configuration-services';
import {TranslateService} from '@ngx-translate/core';
import {DateUtils} from '../../../_shared/date-utils';

@Component({
    selector: 'app-dumpster',
    templateUrl: './dumpster.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DumpsterComponent implements OnInit, OnDestroy {

    @Input() serviceId!: string;
    DeviceStateEnum = DeviceStateEnum;

    crtLang = TranslateUtils.defaultLanguage;
    private langChangeSubscription: Subscription;

    public dumpsters: DumpsterDto[] = [];
    format = DateUtils.dateTimeWithoutSecondFormat;

    constructor(
        private readonly translateService: TranslateService,
        private readonly dumpsterService: DumpsterService) {
    }

    ngOnInit(): void {
        this.crtLang = this.translateService.currentLang;
        this.langChangeSubscription = this.translateService.onLangChange
            .subscribe(_ => {
                this.crtLang = this.translateService.currentLang;
            });
        this.fetchDumpsters();
    }

    ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    canDisplayDumpsterState(dumpster: DumpsterDto) : boolean {
        return dumpster.dumpsterProvider === DumpsterProvider.Koco || dumpster.dumpsterProvider === DumpsterProvider.Bochflow;
    }

    private fetchDumpsters(): void {
        this.dumpsterService.getDumpstersByServiceId(this.serviceId)
            .pipe().subscribe(value => this.dumpsters = value);
    }
}
